/**
 * TruTerritory-theme.js controller
 */

import { baseApi } from "../../../../src/slices/apiSlice";
import { store } from "../../../../src/store";

angular.module("routes:mapping").directive("truterritoryTheme", function ($timeout) {
  return {
    restrict: "A",
    replace: true,
    scope: {
      close: "&",
      onSave: "=",
      onDelete: "=",
    },
    templateUrl: "/truterritory/theme.html",
    controller: function ($scope, Theme) {
      $scope.collection = angular.copy(store.getState().pages.truterritory.currentEditingCollection); // have to copy for angular to use it
      $scope.theme = angular.copy(store.getState().pages.truterritory.currentEditingTheme);
      $scope.parsedCSS = "";
      $scope.saveInProgress = false;

      $scope.legendSetting = 1; // only show if there are other legends
      if ($scope.theme.showLegendHeader && !$scope.theme.customLegendHeader) $scope.legendSetting = 2;
      // always show
      else if ($scope.theme.showLegendHeader) $scope.legendSetting = 3; // custom legend header

      $scope.editorOptions = {
        mode: "cartocss",
        extraKeys: {
          Enter: function () {
            $scope.validateCSS($scope.theme.css);
            return CodeMirror.Pass;
          },
        },
      };

      $scope.save = function () {
        const theme = Theme.dataOnly($scope.theme); // stripping functions since this probably came from Restangular.
        $scope.saveInProgress = true;

        let promise;
        if ($scope.theme.ID) {
          promise = store.dispatch(baseApi.endpoints.updateTheme.initiate($scope.theme)).then(() => $scope.onSave($scope.theme));
        } else {
          promise = store.dispatch(baseApi.endpoints.createTheme.initiate($scope.theme)).then(({ data: newTheme }) => {
            $scope.onSave(newTheme);
            $scope.theme = newTheme;
          });
        }

        promise.finally(() => ($scope.saveInProgress = false));
      };

      $scope.validateCSS = function (css) {
        return Theme.validateCSS(css, $scope.theme.label, $scope.theme.fontSize).then(function (data) {
          $scope.cssErrors = data.errors || {};
          $scope.areErrors = data.errors ? !!Object.keys($scope.cssErrors).length : false;
          $scope.parsedCSS = $scope.areErrors ? "Error(s) in CSS" : data.parsed;
        });
      };

      let previousTimeout;
      $scope.validateCSSOnKeystroke = function (css) {
        $timeout.cancel(previousTimeout);
        previousTimeout = $timeout(function () {
          $scope.validateCSS(css);
        }, 700);
      };

      /**
       * Deletes a theme
       * @return {void}
       */
      $scope.deleteTheme = function () {
        // Send the request
        store.dispatch(baseApi.endpoints.deleteTheme.initiate($scope.theme)).then(() => {
          $scope.onDelete($scope.theme);
          $scope.close();
        });
      };

      $scope.legendTypes = Theme.legendTypes;

      $scope.isLegendColor = function (type) {
        return type && !!type.match(/(\-fill|\-color)$/);
      };

      $scope.legendColorOptions = { showInput: true, showInitial: true, clickoutFiresChange: true, preferredFormat: "hex", allowEmpty: true, showAlpha: true };

      /**
       *
       * @param {Object} prop
       * @param {Object} theme
       *
       * @return {boolean}
       */
      $scope.propertyLabelShouldBeDisabled = function (prop, theme) {
        // A prop label should be disabled if the property can't be labeled and it doesn't currently have a format attached
        let hasFormat = !!theme.labelFormats[prop.name] || theme.labelFormats[prop.name] === 0 || theme.labelFormats[prop.name] === "0";
        let formattableType = $scope.getPgTypeToJs(prop.type) === "number" || $scope.getPgTypeToJs(prop.type) === "unknown";

        return !hasFormat && !formattableType;
      };

      /**
       *
       * @param {string} pgType
       * @return {string}
       */
      $scope.getPgTypeToJs = function (pgType) {
        if (pgType === "varchar" || pgType === "text") {
          return "string";
        } else if (pgType.startsWith("int") || pgType === "numeric" || pgType.startsWith("float") || pgType.endsWith("int")) {
          return "number";
        } else if (pgType === "boolean" || pgType === "bool") {
          return "boolean";
        } else if (pgType.startsWith("timestamp")) {
          return "date";
        } else if (pgType.startsWith("json")) {
          return "json";
        } else if (pgType.endsWith("[]")) {
          return "array";
        } else {
          return "unknown";
        }
      };
    },
  };
});
